type BackHandler = () => void;

let handlers: BackHandler[] = [];

export const pushBackHandler = (handler: BackHandler) => {
  handlers.push(handler);
};

export const popBackHandler = (handler: BackHandler) => {
  handlers = handlers.filter((h) => h !== handler);
};

export const triggerBack = () => {
  const last = handlers[handlers.length - 1];
  if (last) last();
};
